/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetShiftCloseRequest as AgentApiContractSetShiftCloseRequest } from '../../models/AgentApi/Contract/set-shift-close-request';

export interface ApiAgentSetShiftClosePost$Params {

/**
 * interface language/null
 */
  lang?: string;
      body?: AgentApiContractSetShiftCloseRequest
}

export function apiAgentSetShiftClosePost(http: HttpClient, rootUrl: string, params?: ApiAgentSetShiftClosePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgentSetShiftClosePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgentSetShiftClosePost.PATH = '/api/Agent/SetShiftClose';
